import { useTranslation } from "react-i18next";
import { useUserDocumentRoles } from "~/api/v2/useUserDocumentRoles";
import { Link, useParams } from "react-router";
import { CenterSpinner } from "~/atoms/spinner";
import NoResult from "~/molecules/NoResult";
import { Button } from "~/atoms/button";
import HeadingPage from "~/molecules/HeadingPage";

export default function OffboardUserPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: roles, isLoading: isLoadingRoles } = useUserDocumentRoles(id);

  if (id === undefined) {
    return null;
  }

  if (isLoadingRoles) {
    return <CenterSpinner />;
  }

  if (!roles) {
    return <NoResult />;
  }

  return (
    <div className="container space-y-2 py-7">
      <HeadingPage title={t(($) => $.settings.userManagement.disableUser)} />
      <div>{t(($) => $.settings.userManagement.hasDocumentRoles)}</div>
      <div className="grid grid-cols-2">
        <div className="space-y-2">
          <h2 className="text-xl font-semibold">
            {t(($) => $.commons.document.owner)}
          </h2>
          <ul className="list-disc space-y-1 pl-5">
            {roles.ownerIn.map((d) => (
              <li key={`owner-${d.documentId}`}>
                <Button asChild variant="link">
                  <Link to={`/documents/${d.documentId}`}>{d.title}</Link>
                </Button>
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-2">
          <h2 className="text-xl font-semibold">
            {t(($) => $.commons.document.publisher)}
          </h2>
          <ul className="list-disc space-y-1 pl-5">
            {roles.publisherIn.map((d) => (
              <li key={`publisher-${d.documentId}`}>
                <Button asChild variant="link">
                  <Link to={`/documents/${d.documentId}`}>{d.title}</Link>
                </Button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
